import { useState } from "react";
import { Icon } from "../lib/Icon";
import { BRANDS, BRAND_ORDER } from "./brands";
import { usePortal } from "./state";

/**
 * The space switcher (COMPONENTS.md SpaceSwitcher): platform docs + the client
 * spaces the user belongs to (locked spaces shown as locked, never hidden), the
 * one-line explanation of the two content sources, then the other brands.
 */
export function SpaceSwitcher() {
  const { brand, spaceId, setSpace, setBrand } = usePortal();
  const [open, setOpen] = useState(false);
  const space = brand.spaces.find((s) => s.id === spaceId) ?? brand.spaces[0]!;

  return (
    <div style={{ position: "relative", flex: "none" }}>
      <button
        onClick={() => setOpen((v) => !v)}
        style={{
          border: "1px solid var(--onBd)",
          background: "var(--onBg)",
          color: "var(--on)",
          borderRadius: 3,
          padding: "6px 10px",
          display: "flex",
          alignItems: "center",
          gap: 8,
          fontSize: 12.5,
          fontWeight: 500,
          maxWidth: 180,
          cursor: "pointer",
        }}
      >
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{space.name}</span>
        <Icon name="chevrons-up-down" size={13} color="var(--on2)" />
      </button>

      {open && (
        <>
          {/* click-away scrim */}
          <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 19 }} />
          <div style={{ position: "absolute", top: 38, left: 0, width: 308, background: "#fff", borderRadius: 3, boxShadow: "0 8px 26px rgba(0,0,0,.16), inset 0 0 0 1px rgba(0,0,0,.08)", overflow: "hidden", zIndex: 20 }}>
            <div style={{ padding: "11px 14px 8px", fontSize: 10, fontWeight: 600, letterSpacing: 1.4, textTransform: "uppercase", color: "#8a8e88" }}>{brand.name} spaces</div>
            <div style={{ padding: "0 14px 9px", fontSize: 11.5, lineHeight: 1.5, color: "#8a8e88", textWrap: "pretty" }}>{brand.pushNote}</div>
            {brand.spaces.map((sp) => {
              const active = sp.id === spaceId;
              return (
                <button
                  key={sp.id}
                  onClick={() => {
                    if (sp.locked) return;
                    setSpace(sp.id);
                    setOpen(false);
                  }}
                  style={{
                    width: "100%",
                    border: 0,
                    borderTop: "1px solid #f4f3ee",
                    background: active ? "#f4f3ef" : "#fff",
                    padding: "10px 14px",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 10,
                    textAlign: "left",
                    cursor: sp.locked ? "not-allowed" : "pointer",
                  }}
                >
                  <Icon name={sp.kind === "Platform" ? "book-open" : "building-2"} size={15} color={active ? "var(--bi)" : "#8a8e88"} />
                  <span style={{ minWidth: 0, flex: 1 }}>
                    <span style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#1d241f" }}>{sp.name}</span>
                    <span style={{ display: "block", fontSize: 11.5, color: "#8a8e88", marginTop: 2, textWrap: "pretty" }}>{sp.note}</span>
                  </span>
                  {sp.locked && <Icon name="lock" size={13} color="#bcbfba" />}
                </button>
              );
            })}
            <div style={{ borderTop: "1px solid #f4f3ee", padding: "11px 14px 9px", fontSize: 10, fontWeight: 600, letterSpacing: 1.4, textTransform: "uppercase", color: "#8a8e88" }}>Other products</div>
            {BRAND_ORDER.filter((k) => k !== brand.id).map((k) => {
              const bb = BRANDS[k];
              return (
                <button
                  key={k}
                  onClick={() => {
                    setBrand(k);
                    setOpen(false);
                  }}
                  style={{ width: "100%", border: 0, borderTop: "1px solid #f4f3ee", background: "#fff", padding: "9px 14px", display: "flex", alignItems: "center", gap: 10, textAlign: "left", fontSize: 13, fontWeight: 500, color: "#1d241f", cursor: "pointer" }}
                >
                  <span style={{ width: 9, height: 9, borderRadius: 2, background: bb.ink, flex: "none" }} />
                  {bb.name}
                  <span style={{ flex: 1 }} />
                  <span style={{ fontSize: 11, color: "#8a8e88" }}>{bb.kicker}</span>
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
